module.exports = __webpack_public_path__ + "img/default_avatar.4e66133b.png";